import React from 'react'
import { generateRegistryRequestLink } from '../../classes/lib-common'

const RegistryUrl = (props) => {
    const url = generateRegistryRequestLink(props.language, props.name, props.version)
    if(!url || !url.length) return null
    return <a href={url} className={props.class} target="_blank" rel="noopener noreferrer">
        <i className="ml-1 mr-2 fa fa-external-link"></i>
    </a>
}


export default RegistryUrl